import { PropAsset } from './PropAsset';

// Cart - At Arabası
// TODO: Replace with SVG asset
export class Cart extends PropAsset {
  readonly id = 'cart';
  readonly width = 55;
  readonly height = 48;
  readonly walkable = false;
  readonly collisionRadius = 1.0;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.15)';
    ctx.beginPath();
    ctx.ellipse(cx, cy - 2 * s, 22 * s, 8 * s, 0, 0, Math.PI * 2);
    ctx.fill();

    // Wheels - Tekerlekler
    ctx.fillStyle = '#4a3628';
    ctx.strokeStyle = '#3a2618';
    ctx.lineWidth = 2 * s;

    // Left wheel
    ctx.beginPath();
    ctx.arc(cx - 14 * s, cy - 7 * s, 7 * s, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();

    // Right wheel
    ctx.beginPath();
    ctx.arc(cx + 14 * s, cy - 7 * s, 7 * s, 0, Math.PI * 2);
    ctx.fill();
    ctx.stroke();

    // Wheel spokes
    ctx.strokeStyle = '#5a4638';
    ctx.lineWidth = 1 * s;
    for (let i = 0; i < 4; i++) {
      const angle = (i / 4) * Math.PI * 2;
      // Left wheel spokes
      ctx.beginPath();
      ctx.moveTo(cx - 14 * s, cy - 7 * s);
      ctx.lineTo(cx - 14 * s + Math.cos(angle) * 5 * s, cy - 7 * s + Math.sin(angle) * 5 * s);
      ctx.stroke();
      // Right wheel spokes
      ctx.beginPath();
      ctx.moveTo(cx + 14 * s, cy - 7 * s);
      ctx.lineTo(cx + 14 * s + Math.cos(angle) * 5 * s, cy - 7 * s + Math.sin(angle) * 5 * s);
      ctx.stroke();
    }

    // Cart body - Araba gövdesi
    ctx.fillStyle = '#6b5335';
    ctx.fillRect(cx - 18 * s, cy - 22 * s, 36 * s, 14 * s);

    // Cart sides - Araba kenarları
    ctx.fillStyle = '#5b4325';
    ctx.fillRect(cx - 18 * s, cy - 26 * s, 36 * s, 5 * s);

    // Cart front/back walls
    ctx.fillRect(cx - 20 * s, cy - 26 * s, 4 * s, 18 * s);
    ctx.fillRect(cx + 16 * s, cy - 26 * s, 4 * s, 18 * s);

    // Handle - Sap
    ctx.strokeStyle = '#4a3628';
    ctx.lineWidth = 2 * s;
    ctx.beginPath();
    ctx.moveTo(cx + 20 * s, cy - 16 * s);
    ctx.lineTo(cx + 30 * s, cy - 12 * s);
    ctx.stroke();

    // Cargo (hay/goods) - Yük
    ctx.fillStyle = '#b8a060';
    ctx.beginPath();
    ctx.moveTo(cx - 14 * s, cy - 22 * s);
    ctx.lineTo(cx - 10 * s, cy - 28 * s);
    ctx.lineTo(cx + 10 * s, cy - 30 * s);
    ctx.lineTo(cx + 14 * s, cy - 22 * s);
    ctx.closePath();
    ctx.fill();
  }
}
